import { useCallback } from 'react';
import { type SearchResults } from 'algoliasearch-helper';

import { CheckboxFilter } from '~/components/BettingInsights/components/Filters/CheckboxFilter';
import { type BettingInsightsResultAttribute, type EsIndex } from '~/configuration/types';
import { type RepubCountry } from '~/vendor/cx-web/domain-types';

import { trackDateFilterChange } from '../../tracking';

import { transformFieldLabel } from './utils/transformFieldLabel';

export function DateRefinement<TIndex extends EsIndex>({
  attribute,
  isDisabled = false,
  label,
  repubCountry,
}: {
  attribute: BettingInsightsResultAttribute<TIndex>;
  isDisabled?: boolean;
  label: string;
  repubCountry: RepubCountry;
}) {
  const sortBy = useCallback<(a: SearchResults.FacetValue, b: SearchResults.FacetValue) => number>((a, b) => {
    const aVal = a.escapedValue;
    const bVal = b.escapedValue;

    const isIsoFormat = /^\d{4}-\d{2}-\d{2}$/.test(aVal);

    if (isIsoFormat) {
      return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
    } else {
      return Number(aVal) < Number(bVal) ? -1 : 1;
    }
  }, []);

  return (
    <CheckboxFilter
      attribute={attribute}
      isDisabled={isDisabled}
      label={label}
      limit={2}
      repubCountry={repubCountry}
      showMore
      showMoreLimit={20}
      sortBy={sortBy}
      trackChange={value => {
        trackDateFilterChange(value);
      }}
      transformFieldLabel={transformFieldLabel}
    />
  );
}
